<template>
  <layout logoColor="black" toolbarColor="white">

    <v-container>
      <h1>Lender FAQ</h1>

      <div class="grid-wrapper">
        <template v-for="(item, index) in faqs.content">
          <h3 :key="index">{{ index + 1 }}</h3>
          <div :key="item.title">
            <h3>{{ item.title }}</h3>
            <p v-html="item.description"></p>
          </div>
        </template>
      </div>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/modules/home/components/ui/layout'

import faqData from '@/data/faq.json'

export default {
  name: 'FaqPage',
  components: {
    Layout,
  },
  data: () => ({
    faqs: faqData,
  }),
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 120px;
}

.grid-wrapper {
  margin: 30px 0;

  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto;

  grid-column-gap: 15px;
  grid-row-gap: 20px;
}

h1 {
  color: $textDark;
  font-size: 36px;
}

h3 {
  color: $textDarkMuted;
  margin-bottom: 5px;
}

p {
  color: $textDarkMuted;
  font-family: "Avenir Roman";
}

::v-deep {
  .container a {
    color: $primaryBlue !important;

    &:hover { color: rgba($primaryBlue, 0.8) !important; }
  }

  main, .v-main {
    background-color: $backGrey;
  }
}
</style>
